export enum HalfSheetHashType {
  FLIGHT_DETAILS = "flightDetails",
  FLIGHT_DETAILS_DEPARTURE = "flightDetailsDeparture",
  FLIGHT_DETAILS_RETURN = "flightDetailsReturn",
}
